import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageComponent } from './image/image.component';
import { VideoComponent } from './video/video.component';
import { AudioComponent } from './audio/audio.component';
import { OrientationAlertComponent } from './orientation-alert/orientation-alert.component';
import {RouterModule} from '@angular/router';



@NgModule({
  declarations: [
    ImageComponent,
    VideoComponent,
    AudioComponent,
    OrientationAlertComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    ImageComponent,
    VideoComponent,
    AudioComponent,
    OrientationAlertComponent
  ]
})
export class SharedModule { }
